import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/08/principle/speech.svg`,
        },
      },
      styles: {
        padding: "3%",
        maxWidth: "80%",
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/02/08/principle/speech.wav`,
      text: "Sound sample",
      icon: "cis-volume-high",
      shape: "round",
      theme: "secondary",
    },
  },
];
